<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" align="center">
        <img :src="image" width="35%" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "error400",

  data() {
    return {
      image: require("@/assets/images/404.png")
    };
  }
};
</script>

<style scoped>
@media (max-width: 575.98px) {
  img {
    width: 95%;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  img {
    width: 95%;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  img {
    width: 70%;
  }
}
</style>